import Icon from "@/icons";

export default function Bottom({ setIsOpen, notIncludeUsers }: { setIsOpen: any, notIncludeUsers?: boolean }) {
    return (
        <div className="sm:hidden bottom-0 w-full flex max-h-16 bg-brand-dark p-3 justify-center px-8 items-center gap-24 z-50">
            <div className="items-center flex flex-col">
                <button className="text-white bg-brand-hover px-4 py-2 rounded-md" onClick={() => setIsOpen(2)}>
                    <Icon name="list" size="24" color="white" />
                </button>
                <p className="text-white text-xs font-bold">List</p>
            </div>
            <div className="items-center flex flex-col">
                <button className="text-white bg-brand-hover px-4 py-2 rounded-md" onClick={() => setIsOpen(1)}>
                    <Icon name="message" size="24" color="white" />
                </button>
                <p className="text-white text-xs font-bold">Content</p>
            </div>
            {!notIncludeUsers && <div className="items-center flex flex-col">
                <div className="items-center flex flex-col">
                    <button className="text-white bg-brand-hover items px-4 py-2 rounded-md" onClick={() => setIsOpen(0)}>
                        <Icon name="users" size="24" color="white" />
                    </button>
                    <p className="text-white text-xs font-bold">Members</p>
                </div>
            </div>}
        </div>);
}
